import { render } from "./VCloudDetail.vue?vue&type=template&id=a751de52&scoped=true"
import script from "./VCloudDetail.vue?vue&type=script&lang=js"
export * from "./VCloudDetail.vue?vue&type=script&lang=js"

import "./VCloudDetail.vue?vue&type=style&index=0&id=a751de52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a751de52"]])

export default __exports__